import { request } from "../request";

// 售后服务列表
export function getList(data) {
  return request({
    url: "/aftersale/getList",
    data,
    method: "post",
  });
}

// 获取收货地址列表
export function addressList(data) {
  return request({
    url: "/aftersale/addressList",
    data,
    method: "post",
  });
}

// 删除收货地址
export function addressDelete(data) {
  return request({
    url: "/aftersale/addressDelete",
    data,
    method: "post",
  });
}

// 添加收货地址
export function addressAdd(data) {
  return request({
    url: "/aftersale/addressAdd",
    data,
    method: "post",
  });
}

// 修改收货地址
export function addressEdit(data) {
  return request({
    url: "/aftersale/addressEdit",
    data,
    method: "post",
  });
}

// 获取维修产品成本列表
export function costList(data) {
  return request({
    url: "/aftersale/costList",
    data,
    method: "get",
  });
}

// 提交维修工单
export function createAftersale(data) {
  return request({
    url: "/aftersale/create",
    data,
    method: "post",
  });
}

// 提交维修工单
export function getDetail(data) {
  return request({
    url: "/aftersale/getDetail",
    data,
    method: "post",
  });
}

// 取消工单
export function cancel(data) {
  return request({
    url: "/aftersale/cancel",
    data,
    method: "post",
  });
}

// 设置邮件单号
export function setTrackingNumber(data) {
  return request({
    url: "/aftersale/setTrackingNumber",
    data,
    method: "post",
  });
}

// 确认收货
export function confirmReceipt(data) {
  return request({
    url: "/aftersale/confirmReceipt",
    data,
    method: "post",
  });
}

// 客户是否同意维修
export function confirmRepair(data) {
  return request({
    url: "/aftersale/confirmRepair",
    data,
    method: "post",
  });
}

// ====== 新版售后工单接口 ======

// 提交售后工单(新)
export function createNewAftersale(data) {
  return request({
    url: "/aftersale/createNew",
    data,
    method: "post",
    timeout: 300000, // 5分钟，大附件提交到ZOHO可能较慢
  });
}

// 保存售后工单草稿
export function saveDraft(data) {
  return request({
    url: "/aftersale/saveDraft",
    data,
    method: "post",
  });
}

// 获取售后工单草稿
export function getDraft(data) {
  return request({
    url: "/aftersale/getDraft",
    data,
    method: "post",
  });
}

// 删除售后工单草稿
export function deleteDraft(data) {
  return request({
    url: "/aftersale/deleteDraft",
    data,
    method: "post",
  });
}

// 上传附件到服务器
export function uploadToLocal(formData) {
  return request({
    url: "/aftersale/uploadToLocal",
    data: formData,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 300000,
  });
}
